/* eslint-disable */

/* @description Desktop Client 基类, 将桌面端提供的所有接口暴露给JS*/
class IDesktopClient {
  /* @description 构造函数*/
  constructor() {}
  /*
  @description 设置错误处理回调函数
  @params errorHandler:Function 错误处理回调函数, 其签名为: (errorCode:String, errorMessage:String) -> void
  @
  @return void
  */
  SetErrorHandler(errorHandler) {
    this.errorHandler = errorHandler;
  }
  /*
  @description 检查response是否有错误, 若有则调用错误处理回调函数
  @params response IDesktopClient接口的响应结果
  @
  @return <response>
  */
  __FilterError(response) {
    if (response.code == "success") {
      return response;
    }
    if (typeof this.errorHandler == "undefined" || this.errorHandler == null) {
      return response;
    }

    this.errorHandler(response.code, response.message);
    return response;
  }
  /*
  @description 自定义JSON反序列化
  */
  __JSONParse(jsonStr) {
    const bigIntMarker = "{42832FF8-64BC-4FEC-97A8-1F628767D127}:";
    const isBigInt = (numStr) => {
      return numStr && !Number.isSafeInteger(+numStr);
    };
    const markBigInt = (jsonStr) => {
      if (typeof jsonStr != "string") {
        return jsonStr;
      }
      return jsonStr.replaceAll(
          /([:\[,]+[\s]*)(\d+)([\s]*[,\]]+)/g,
          (matchingSubstr, prefix, numStr, suffix) =>
              isBigInt(numStr)
                  ? `${prefix}"${bigIntMarker}${numStr}"${suffix}`
                  : matchingSubstr
      );
    };
    const recongizeMarkedBigInt = (value) => {
      if (typeof value != "string" || !value.startsWith(bigIntMarker)) {
        return {
          markedAsBigInt: false,
          bigIntStr: undefined,
        };
      }
      return {
        markedAsBigInt: true,
        bigIntStr: value.substring(bigIntMarker.length).trim(),
      };
    };
    const jsonReviver = (key, value) => {
      const { markedAsBigInt, bigIntStr } = recongizeMarkedBigInt(value);
      if (markedAsBigInt) {
        return BigInt(bigIntStr);
      }
      return value;
    };

    return JSON.parse(markBigInt(jsonStr), jsonReviver);
  }
  /*
  @description 获取桌面端提供的所有接口的默认响应结果
  @params void
  @
  @return 桌面端提供的所有接口的默认响应结果
  */
  #DefaultResponse() {
    return new Promise((resolve) => {
      resolve(
          this.__FilterError({
            code: "request.method.not.found",
            message: "not implemented!",
            data: null,
          })
      );
    });
  }
  /*
  @description 调用桌面端接口，通用入口
  @params method:String 要调用的桌面端函数签名
  @params params:Object 桌面端函数所需的参数
  @
  @return a Promise. resolve 的结果为：
      {
          code: String,
          message: String,
          data: <data>
      }
      code 为success表示成功
      data 为实际执行结果
  */
  CallDesktop(method, params) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取桌面端基本信息
  @params void
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 桌面端基本信息，其结构为：
      {
        clientType: string,
        desktopName: string,
        desktopVersion: string,
        hostPlatformCode: string,
        hostAppName: string,
        hostAppVersion: string,
        pluginName: string,
        pluginVersion: string,
        machineCode: string,
        osVersion: string,
        screenResolutions: string
      }
  */
  GetDesktopInfo() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，打开默认浏览器跳转到指定链接
  @params targetUrl:String 要打开的目标链接
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  NavigateToBrowser(targetUrl) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取特殊目录的地址
  @params type:String 特殊目录类型，可选值如下：
               'LocalApplicationData' - 本地应用程序数据目录，对应环境变量%localappdata%
               'UserProfile' - 用户档案目录，对应环境变量%userprofile%
               'Temporary' - 临时目录，对应环境变量%temp%
               ...
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: String
      }
      code - 为success表示成功
      data - 对应的特殊目录的全路径
  */
  GetSpecialFolder(type) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，删除文件
  @params filePath:String 文件路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DeleteFile(filePath) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，批量删除文件
  @params dirPath:String 文件夹地址
  @params recursive:bool 是否递归查找子目录，默认false
  @params filter:String 要删除文件的过滤器，例如：'*.rvt|*.dwg'，默认为全部(*.*）
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DeleteFiles(dirPath, recursive, filter) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，检查文件是否存在
  @params filePath:String 文件路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若存在，则为true，否则，为false
  */
  ExistFile(filePath) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，检查文件夹是否存在
  @params dirPath:String 文件夹路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若存在，则为true，否则，为false
  */
  ExistDirectory(dirPath) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，创建文件夹
  @note 任一层级上的文件夹若不存在，则均会进行创建
  @params dirPath:String 文件夹路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  CreateDirectory(dirPath) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，判断文件夹是否为空
  @params dirPath:String 文件夹路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若为空，则为true，否则，为false
  */
  IsDirectoryEmpty(dirPath) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，删除文件夹
  @params dirPath:String 文件夹路径
  @params recursive:Boolean 是否递归删除文件夹内所有内容，包括子文件夹
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DeleteDirectory(dirPath, recursive) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，从文件中读取文本
  @params filePath:String 文件路径
  @params encoding:String 编码类型，默认UTF-8
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: String
      }
      code - 为success表示成功
      data - 文本内容
  */
  ReadTextFromFile(filePath, encoding) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，向文件中写入文本
  @note 若文件存在，则内容会被覆盖
  @params filePath:String 文件路径
  @params content:String 文本内容
  @params encoding:String 编码类型，默认UTF-8
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  WriteTextToFile(filePath, content, encoding) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，复制文件
  @params srcFilePath:String 源文件路径
  @params destFilePath:String 目标文件路径
  @params overwrite:bool 若目标文件已存在，是否覆盖，默认为true
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  CopyFile(srcFilePath, destFilePath, overwrite) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，从远程下载文件
  @params remoteUrl:String 远程Url地址
  @params localFilePath:String 本地文件路径
  @params overwrite:bool 若本地文件已存在，是否覆盖，默认为true
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DownloadFile(remoteUrl, localFilePath, overwrite) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，从远程下载文件(支持取消)
  @params remoteUrl:String 远程Url地址
  @params localFilePath:String 本地文件路径
  @params overwrite:bool 若本地文件已存在，是否覆盖，默认为true
  @params cancelToken:string 用于取消的令牌，可使用GUID
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DownloadFileCancelable(remoteUrl, localFilePath, overwrite, cancelToken) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，取消指定任务
  @params cancelToken:string 用于取消的令牌，可使用GUID
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  CancelTask(cancelToken) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取文件的MD5
  @params filePath:String 文件路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: String
      }
      code - 为success表示成功
      data - MD5
  */
  GetFileMd5(filePath) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，开启当前窗口蒙层
  @params options:Object 选项，其结构如下：
      {
       region:String, 蒙层区域，可选值如下：
               "R_TITLE_BAR", 标题栏
               "R_CLIENT_AREA", 客户区
               "R_OVERALL", 全部
               ...
      }
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
      data - void
  */
  ShowMask(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，关闭当前窗口蒙层
  @params options:Object 选项，其结构如下：
      {
       region:String, 蒙层区域，可选值如下：
               "R_TITLE_BAR", 标题栏
               "R_CLIENT_AREA", 客户区
               "R_OVERALL", 全部
               ...
      }
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
      data - void
  */
  HideMask(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，根据一组构件名称获取当前文档中的的构件信息
  @params componentNames:array<String> 构件名称列表
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: array<Object>
      }
      code - 为success表示成功
      data - 通过名称匹配到的构件对象列表，其结构为：
      [
          {
            familyName: String,     // 构件名称
            familyId: String,       // 构件ElementId
            instanceCount: Integer, // 构件对应的实例数量
          }
      ]
  */
  ListComponentsByNames(componentNames) {
    return this.#DefaultResponse();
  }
  /*
   @description 调用桌面端，载入构件
   @params options:Object, 构件载入选项，其结构为：
        {
          userId:String, 用户ID
          id:String, 构件资源ID
          digitalComponentId:Long, 数字构件ID
          softwareVersionId:Long, 构件资源软件版本ID
          dataVersionId:Long, 构件资源数据版本ID
          name:String, 构件名称
          suffix:String, 构件后缀（不含点）
          filePath: String, 构件文件路径
          familyFoundStrategy: String, 若发现同名构件应采取的策略，可选值如下：
                                "FFS_CREATE", 重命名后创建新的族
                                "FFS_OVERWRITE", 覆盖已有的同名的族
          thumbnail: String, 缩略图地址
          softwareCategoryNames: array<String>, 软件分类名称列表
          softwareCategoryCodes: array<String>, 软件分类编码列表
          softwareVersion: String, 软件版本
          storeId: String, 文件存储ID
          source: String 构件源类型，可选值有：
                              "PublicSpace", 公共空间，
                              "TeamSpace", 团队空间
        }
    @
    @return a Promise. resolve 结果为：
        {
            code: String,
            message: String,
            data: Object
        }
        code - 为success表示成功
        data - 载入后的构件信息，其结构为：
        {
            familyId: String,       // 构件ElementId
            familyName: String,     // 构件名称
        }
  */
  LoadComponent(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，布置构件
  @params options:Object, 构件布置选项，其结构为：
      {
        userId:String, 用户ID
        id: String, 构件资源ID
        digitalComponentId:Long, 数字构件ID
        softwareVersionId:Long, 构件资源软件版本ID
        dataVersionId:Long, 构件资源数据版本ID
        name:String, 构件名称
        suffix:String, 构件后缀（不含点）
        filePath: String, 构件文件路径
        familyFoundStrategy: String, 若发现同名构件应采取的策略，可选值如下：
                              "FFS_CREATE", 重命名后创建新的族
                              "FFS_OVERWRITE", 覆盖已有的同名的族
        thumbnail: String, 缩略图地址
        softwareCategoryNames: array<String>, 软件分类名称列表
        softwareCategoryCodes: array<String>, 软件分类编码列表
        softwareVersion: String, 软件版本
        storeId: String, 文件存储ID
        source: String 构件源类型，可选值有：
                            "PublicSpace", 公共空间，
                            "TeamSpace", 团队空间
        familyId: String, 要布置的族ElementId（若设置，则不再载入族，直接使用）
        typeNameToBePlaced:String, 要布置的族类型名称
        loadAllTypes:bool, 是否载入所有族类型
        typeNames:Array<String>, 所有族类型名称列表
        instanceParameters: 布置后要写入的实例参数列表
        [
          {
            parameterCode: String, 参数编码
            guid: String, 参数GUID
            name: String, 参数名称
            value: String, 参数值
            unitCode: String, 参数单位编码
            unit: String 参数单位符号
          }
        ]
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  PlaceComponent(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，根据文件所在目录获取模型链接
  @params dirPath:String 文件所在目录地址
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: array<Object>
      }
      code - 为success表示成功
      data - 模型链接对象列表，其结构为：
      [
          {
            linkId: Long,       // 模型链接ElementId
            linkPath: String,   // 模型链接文件路径
          }
      ]
  */
  ListModelLinksByDirPath(dirPath) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，链接模型
  @params options:Object, 选项，其结构为：
      {
        userId:String, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
        filePath: String, 文件路径
        placement:String, 定位方式，可选值如下：
                 "P_AUTO_CENTERED", 自动 - 中心到中心
                 "P_AUTO_ORIGIN", 自动 - 内部原点到内部原点
                 "P_AUTO_SHARED", 自动 -  通过共享坐标
                 "P_AUTO_SITE", 自动 - 项目基点到项目基点
                 "P_MANUAL_ORIGIN", 手动 - 内部原点
                 "P_MANUAL_SITE", 手动 - 基点
                 "P_MANUAL_CENTERED", 手动 - 中心
                 ...
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  LinkModel(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，重新载入模型链接
  @params linkId:Long, 要重载的模型链接的ElementId
  @params options:Object, 选项，其结构为：
       {
         userId:String, 用户ID
         fileId:Long, 文件ID
         fileRevisionId:Long, 文件修订版本ID
       }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadModelLink(linkId, options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，重新载入模型链接，来自新的位置
  @params filePath:String, 新的文件位置
  @params linkId:Long, 要重载的模型链接的ElementId
  @params options:Object, 选项，其结构为：
      {
        userId:String, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadModelLinkFrom(filePath, linkId, options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，根据文件所在目录获取CAD链接
  @params dirPath:String 文件所在目录地址
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: array<Object>
      }
      code - 为success表示成功
      data - CAD链接对象列表，其结构为：
      [
          {
            linkId: Long,       // CAD链接ElementId
            linkPath: String,   // CAD链接文件路径
          }
      ]
  */
  ListCADLinksByDirPath(dirPath) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取当前视图信息
  @params void
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 当前视图信息，其结构为：
      {
          viewId: Long,       // 视图ElementId
          viewType: String,   // 视图类型，可选值如下：
                                  "FloorPlan", 楼层平面
                                  "CeilingPlan", 天花板平面
                                  "AreaPlan", 面积平面
                                  "Elevation", 立面
                                  "ThreeD", 三维
                                  ...,
                                  "TwoDimensional", 二维（数维）
                                  "ThreeDimensional", 三维（数维）
                                  "Perspective", 透视（数维）
                                  "Drawing", 图纸（数维）
                                  ...
          title: String,      // 视图标题
          genLevelId: Long    // 生成此视图所基于的标高ElementId
      }
  */
  GetActiveView() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取标高列表
  @params void
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: array<Object>
      }
      code - 为success表示成功
      data - 标高列表，其结构为：
      [
          {
              levelId:Long,       // 标高ElementId
              elevation:double,   // 高度
              name:String,        // 名称
              ownerViewId:Long,   // 所属视图ELementId
          }
      ]
  */
  ListLevels() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，链接CAD
  @params options:Object, CAD链接选项，其结构为：
       {
         userId:String, 用户ID
         filedId:Long, 文件ID
         fileRevisionId:Long, 文件修订版本ID
         filePath: String, 文件路径
         placement:String, 定位方式，可选值如下：
                  "P_AUTO_CENTERED", 自动 - 中心到中心
                  "P_AUTO_ORIGIN", 自动 - 内部原点到内部原点
                  "P_AUTO_SHARED", 自动 -  通过共享坐标
                  "P_AUTO_SITE", 自动 - 项目基点到项目基点
                  "P_MANUAL_ORIGIN", 手动 - 内部原点
                  "P_MANUAL_SITE", 手动 - 基点
                  "P_MANUAL_CENTERED", 手动 - 中心
                  ...
         colorMode:String, 颜色模式，可选值如下：
                  "CM_PRESERVED", 保留
                  "CM_INVERTED", 反选
                  "CM_BLACK_AND_WHITE", 黑白
         layerMode:String, 图层导入模式，可选值如下：
                  "LM_ALL", 全部
                  "LM_VISIBLE_ONLY", 可见
                  "LM_SPECIFIED", 指定
         unit:String, 单位，可选值如下：
                  "UT_DEFAULT", 默认
                  "UT_FOOT", 英尺
                  "UT_INCH", 英寸
                  "UT_METER, 米
                  "UT_DECIMETER", 分米
                  "UT_CENTIMETER", 厘米
                  "UT_MILLIMETER", 毫米
                  "UT_CUSTOM", 自定义
                  "UT_US_SURVEY_FOOT", 美制测量英尺
         customScale:double, 自定义缩放系数
         levelId:Long, 标高ElementId
         thisViewOnly:bool, 是否仅当前视图
         orientToView:bool, 是否定向到视图
         autoCorrectAlmostVHLines:bool, 是否纠正稍微偏离轴的线
       }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  LinkCAD(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，重新载入CAD链接
  @params linkId:Long, 要重载的CAD链接的ElementId
  @params options:Object, 选项，其结构为：
      {
        userId:String, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadCADLink(linkId, options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，重新载入CAD链接
  @params filePath:String, 新的文件位置
  @params linkId:Long, 要重载的CAD链接的ElementId
  @params options:Object, 选项，其结构为：
      {
        userId:String, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadCADLinkFrom(filePath, linkId, options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，导入CAD
  @params options:Object, CAD导入选项，其结构为：
      {
        userId:Long, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
        filePath: String, 文件路径
        placement:String, 定位方式，可选值如下：
                 "P_AUTO_CENTERED", 自动 - 中心到中心
                 "P_AUTO_ORIGIN", 自动 - 内部原点到内部原点
                 "P_AUTO_SHARED", 自动 - 通过共享坐标
                 "P_AUTO_SITE", 自动 - 项目基点到项目基点
                 "P_MANUAL_ORIGIN", 手动 - 内部原点
                 "P_MANUAL_SITE", 手动 - 基点
                 "P_MANUAL_CENTERED", 手动 - 中心
                 ...
        colorMode:String, 颜色模式，可选值如下：
                 "CM_PRESERVED", 保留
                 "CM_INVERTED", 反选
                 "CM_BLACK_AND_WHITE", 黑白
        layerMode:String, 图层导入模式，可选值如下：
                 "LM_ALL", 全部
                 "LM_VISIBLE_ONLY", 可见
                 "LM_SPECIFIED", 指定
        unit:String, 单位，可选值如下：
                 "UT_DEFAULT", 默认
                 "UT_FOOT", 英尺
                 "UT_INCH", 英寸
                 "UT_METER, 米
                 "UT_DECIMETER", 分米
                 "UT_CENTIMETER", 厘米
                 "UT_MILLIMETER", 毫米
                 "UT_CUSTOM", 自定义
                 "UT_US_SURVEY_FOOT", 美制测量英尺
        customScale:double, 自定义缩放系数
        levelId:Long, 标高ElementId
        thisViewOnly:bool, 是否仅当前视图
        orientToView:bool, 是否定向到视图
        autoCorrectAlmostVHLines:bool, 是否纠正稍微偏离轴的线
        viewId:Long, 视图ID
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ImportCAD(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，选择本地文件
  @params options:Object 选项，其结构如下：
      {
       title:String, 窗口标题
       filter:String, 文件类型过滤器，例如："Revit族文件(*.rfa)|*.rfa|Revit项目文件(*.rvt)|*.rvt"
       initialDirectory:String, 初始目录
       restoreDirectory:bool, 是否恢复目录
       multiselect:bool, 是否支持多选
       checkFileExists:bool, 是否校验文件存在
       checkPathExists:bool, 是否校验路径存在
       dereferenceLinks:bool, 是否解引用快捷方式链接
      }
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 文件选择结果，其结构为：
      {
          isCanceled: bool, 用户是否取消选择
          selectedFiles: Array<string>, 所选的文件路径列表
      }
  */
  SelectFiles(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，选择本地文件夹
  @params options:Object 选项，其结构如下：
      {
       initialDirectory:String, 初始目录
       description:String, 描述
       showNewFolderButton:bool, 是否显示新建文件夹按钮(仅对普通对话框生效)
       useFolderBrowserDialog:bool, 是否使用普通对话框，默认false
      }
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 文件选择结果，其结构为：
      {
          isCanceled: bool, 用户是否取消选择
          selectedDirectory: string, 所选的文件夹路径
      }
  */
  SelectDirectory(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，设置文本到剪切板
  @params text:String 要复制的文本
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
      data - void
  */
  ClipboardSetText(text) {
    return this.#DefaultResponse();
  }
  /*
   @description 调用桌面端，载入模块
   @params options:Object, 模块载入选项，其结构为：
        {
          userId:Long, 用户ID
          softwareVersionId:Long, 资源软件版本ID
          dataVersionId:Long, 资源数据版本ID
          name:String, 名称
          suffix:String, 后缀（不含点）
          filePath: String, 文件路径
          guid: String, 主模块GUID
          type: String, 模块类型
          functionType: String, 功能类型
          specialtyType: String, 专业类型
          moduleName: String, 模块名
          moduleFileName: String, 模块文件名
          metaJson: String, 模块meta.json内容
          id:String, 资源ID
          softwareCode: String, 软件编码
          softwareVersion: String, 软件版本
          downloadUrlUrl: String, 获取模块文件下载地址的Url
          source: String 源类型，可选值有：
                              "PublicSpace", 公共空间，
                              "TeamSpace", 团队空间
        }
    @
    @return a Promise. resolve 结果为：
        {
            code: String,
            message: String,
            data: void
        }
        code - 为success表示成功
  */
  LoadModule(options) {
    return this.#DefaultResponse();
  }
  /*
   @description 调用桌面端，打开并激活文档
   @params options:Object, 打开文档选项，其结构为：
      {
        userId:String, 用户ID
        spaceId:String, 空间ID,
        fileId:String, 文件ID
        fileType:String, 文件类型
        fileRevisionId:String, 文件修订版本ID
        filePath:String, 文件路径
        fileName:String, 文件名称
        fileSuffix:String, 文件后缀
      }
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: Object
       }
       code - 为success表示成功,
       data - 所打开文档的信息, 其结构为:
       {
           title: String, 文档标题
           pathName: String, 文档全路径
           isFamilyDocument: bool, 是否为族文档
           isInTransaction: bool, 是否处于事务中
           isLinked: bool, 是否为链接文档
       }
  */
  OpenAndActivateDocument(options) {
    return this.#DefaultResponse();
  }
  /*
   @description 调用桌面端，获取当前激活的文档
   @params void
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: Object
       }
       code - 为success表示成功,
       data - 当前激活文档的信息, 若没有则为null, 其结构为:
       {
           title: String, 文档标题
           pathName: String, 文档全路径
           isFamilyDocument: bool, 是否为族文档
           isInTransaction: bool, 是否处于事务中
           isLinked: bool, 是否为链接文档
       }
  */
  GetActiveDocument() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，载入模板
  @params options:Object, 模板载入选项，其结构为：
       {
         filePath: String, 文件路径
       }
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: void
       }
       code - 为success表示成功
  */
  LoadTemplate(options) {
    return this.#DefaultResponse();
  }
  /*
   @description 调用桌面端，获取当前用户信息
   @params void
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: Object
       }
       code - 为success表示成功,
       data - 当前用户的信息, 若没有则为null, 其结构为:
       {
           id: String, 用户ID
           name: String, 用户名称
           accessToken: String, 访问令牌
       }
  */
  GetUserInfo() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，在资源管理器中显示指定路径的文件或文件夹
  @params path:String 文件或文件夹路径
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  RevealInExplorer(path) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，开启磁盘文件迁移程序
  @params options:Object, 磁盘文件迁移选项，其结构为：
      {
        srcPath:String, 源文件夹路径
        destPath:String, 目标文件夹路径
        bannedProcesses: array<String>, 迁移时需禁止的进程名称列表
        defaultErrorPrompt:String, 迁移出错时的默认提示信息
        finishAction:  迁移结束后的行为
        {
          type: String, 行为类型(UpdateConfig-更新配置文件, ...)
          params:
          {
            configPath: String, 要更新的配置文件路径
            configItems:[ 要更新的配置项列表
              {
                 key: String, 配置项的键(使用jsonPath)
                 value:String, 配置项的值
              }
            ]
          }
        }
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功,
      data - 返回迁移程序信息和状态，其结构为：
      {
         status: String, 当前状态(Started-已开启，ShortOut-已短路，即快速成功),
         program: String, 迁移程序地址
      }
  */
  StartMigration(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，校正文件夹快捷方式(Junction)
  @params srcPath:String, 源文件夹路径
  @params destPath:String, 目标文件夹路径
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示开启成功
  */
  RectifyJunction(srcPath, destPath) {
    return this.#DefaultResponse();
  }
  /*
   @description 调用桌面端，获取文件夹大小
   @params dirPath:String, 文件夹路径
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: String
       }
       code - 为success表示成功,
       data - 文件夹大小，单位为字节
  */
  GetDirectorySize(dirPath) {
    return this.#DefaultResponse();
  }
  /*
   @description 调用桌面端，获取路径所在磁盘的信息
   @params path:String, 文件或文件夹路径
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: Object
       }
       code - 为success表示成功,
       data - 路径所在磁盘的信息，其结构为：
      {
         availableSize: String, 可用空间大小，单位为字节
         totalSize: String, 总空间大小，单位为字节
      }
  */
  GetDriveInfo(path) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，从文件夹创建压缩文件
  @params options:Object 选项，其结构如下：
      {
        srcDirPath:String, 要压缩的源文件夹的路径
        destZipFilePath:String, 要生成的目标压缩文件的路径
        compressionLevel:String, 压缩级别（可选），默认为Optimal，可选值如下：
                                "Optimal", 最优
                                "Fastest", 最快
                                "NoCompression", 无压缩
        includeBaseDirectory:Boolean, 是否包含源文件夹本身（可选），默认为false
        entryNameEncoding:String, 压缩项名称编码（可选），默认为null
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示开启成功
  */
  CreateZipFromDirectory(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，将压缩文件解压提取到指定文件夹内
  @params options:Object 选项，其结构如下：
      {
        srcZipFilePath:String, 要解压的压缩文件的路径
        destDirPath:String, 要解压到的文件夹的路径
        entryNameEncoding:String, 压缩项名称编码（可选），默认为null
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示开启成功
  */
  ExtractZipToDirectory(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，在浏览器内模拟鼠标点击
  @params options:Object 选项，其结构如下：
      {
        x:Number, X坐标
        y:Number, Y坐标
        mouseButtonType:String, 鼠标按钮类型，可选值有：
                    Left - 鼠标左键
                    Middle - 鼠标中键
                    Right - 鼠标右键
        modifiers:String, 键盘修改键标志位，可选值有：
                    None - 0 - 无
                    ShiftDown - 2 - 按下Shift
                    ControlDown - 4 - 按下Control
                    AltDown - 8 - 按下Alt
                    ...
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
  */
  PerformMouseClickInBrowser(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，在浏览器内打开对话框时自动选择指定路径
  @params options:Object 选项，其结构如下：
      {
        autoSelectPaths:Array<string>, 指定要自动选择的路径，一个或多个
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
  */
  SetDialogAutoSelectInBrowser(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，发布Web事件
  @params options:Object 选项，其结构如下：
      {
        eventName:string, 事件名称
        eventArgs:string, 事件参数
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  EmitWebEvent(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，批量载入构件
  @params options:array<Object>, 构件载入选项列表，其结构为：
      [
        {
          userId:String, 用户ID
          id:String, 构件资源ID
          digitalComponentId:Long, 数字构件ID
          softwareVersionId:Long, 构件资源软件版本ID
          dataVersionId:Long, 构件资源数据版本ID
          name:String, 构件名称
          suffix:String, 构件后缀（不含点）
          filePath: String, 构件文件路径
          familyFoundStrategy: String, 若发现同名构件应采取的策略，可选值如下：
                                "FFS_CREATE", 重命名后创建新的族
                                "FFS_OVERWRITE", 覆盖已有的同名的族
          thumbnail: String, 缩略图地址
          softwareCategoryNames: array<String>, 软件分类名称列表
          softwareCategoryCodes: array<String>, 软件分类编码列表
          softwareVersion: String, 软件版本
          storeId: String, 文件存储ID
          source: String 构件源类型，可选值有：
                              "PublicSpace", 公共空间，
                              "TeamSpace", 团队空间
        }
      ]
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: array<Object>
      }
      code - 为success表示成功
      data - 载入后的构件信息列表，其结构为：
      [
        {
          id: String,             // 构件资源ID
          loadResult: String,     // 载入结果：SUCCESS - 成功，FAILURE - 失败， SKIPPED - 跳过
          familyId: String,       // 构件ElementId
          familyName: String,     // 构件名称
        }
      ]
  */
  LoadComponents(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，链接CAD
  @params options:Object, CAD链接选项，其结构为：
       {
         filePath: String, 文件路径
         fileNameSame:bool, 是否文件名重复链接IFC（默认：true）
         tryRelativeType:bool, 使用相对或绝对路径（默认：true，相对路径）
       }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  LinkIFC(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，重新载入模型链接，来自新的位置
  @params filePath:String, 新的文件位置
  @params linkId:Long, 要重载的模型链接的ElementId
  @params options:Object, 选项，其结构为：
      {
        userId:String, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadIFCLinkFrom(filePath, linkId, options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，创建新的浏览器窗口
  @params options:Object, 选项，其结构为：
      {
        url: String, 页面的URL
        width: Number, 窗口宽度，默认为1280
        height: Number, 窗口高度，默认为720
        isModal: Boolean, 是否以模态窗口显示，默认为否
        isResizable: Boolean, 是否可调整大小，默认为是
        switchWindowStateOnDoubleClickTitleBar: Boolean, 是否在双击标题栏时切换窗口状态，默认为是
        showTitleBar: Boolean, 是否显示标题栏，默认为是
        titleBarHeight: Number, 窗口标题栏高度，默认为26
        titleBarBackground: String, 窗口标题栏背景颜色，默认是#DEE3EA
        titleText: String, 窗口标题，默认为空
        showTitleIcon: Boolean, 是否显示标题栏图标，默认为是
        showMinimizeButton: Boolean, 是否显示最小化按钮，默认为是
        showMaximizeButton: Boolean, 是否显示最大化按钮，默认为是
        showCloseButton: Boolean, 是否显示关闭按钮，默认为是
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 结果数据，其结构为：
      {
        dialogResult: Boolean, 对话框的返回结果
      }
  */
  CreateBrowserWindow(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，拖动浏览器窗口
  @note 在页面上，需要通过鼠标拖拽实现窗口移动的部位，在onmousedown事件中调用此方法
  @params void
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 移动浏览器窗口的结果，true/false
  */
  DragMoveBrowserWindow() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，关闭浏览器窗口
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: bool
      }
      code - 为success表示成功
      data - 关闭浏览器窗口的结果，true/false
  */
  CloseBrowserWindow() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，保存Gjw用户信息到插件
  @params gjwUserInfo:Object, Gjw用户信息，其结构为：
      {
        id: String,                 // 用户ID
        name: String,               // 用户名
        accessToken: String,        // 用户访问令牌
      }
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: bool
      }
      code - 为success表示成功
      data - 保存用户信息的结果，true/false
  */
  SaveGjwUserInfo(gjwUserInfo) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取当前浏览器窗口中的自定义输入数据
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: String
      }
      code - 为success表示成功
      data - 保获取到的自定义输入数据字符串
  */
  GetBrowserCustomInputData() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，设置当前浏览器窗口中的自定义输出数据
  @params options:Object, 设置选项，其结构为
      {
        customOutputData: String, 自定义输出数据
        closeWindow: bool, 是否关闭窗口
        dialogResult: 对话框结果（closeWindow=true时生效）
      }
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: bool
      }
      code - 为success表示成功
      data - 设置自定义输出数据的结果，true/false
  */
  SetBrowserCustomOutputData(options) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取当前项目所在地区
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: String
      }
      code - 为success表示成功
      data - 当前项目所在地区
  */
  GetProjectAreaName() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取当前项目信息
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: Object
      }
      code - 为success表示成功
      data - 当前项目信息，其结构为
      {
        id: String,
        name: String,
        path: String
      }
  */
  GetProject() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取宿主软件当前版别
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: String
      }
      code - 为success表示成功
      data - 宿主软件当前版别
  */
  GetHostEdition() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取从宿主软件唤起插件的入口
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: String
      }
      code - 为success表示成功
      data - 从宿主软件唤起插件的入口
  */
  GetHostFromEntrance() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取宿主软件当前环境
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: String
      }
      code - 为success表示成功
      data - 宿主软件当前环境名称
  */
  GetHostActiveEnv() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取宿主软件当前环境下指定key的远程终结点地址
  @params key:String 要查询的终结点的key
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: String
      }
      code - 为success表示成功
      data - 宿主软件当前环境名称
  */
  GetHostEndpoint(key) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，发送埋点到构件坞服务端
  @note 此接口仅为兼容旧的调用，请勿再新增使用，网页可自行往服务端发送埋点
  @params eventName 事件名称
  @params eventParams 事件参数
  @
  @return a Promise. resolve 结果为：
    {
        code: String,
        message: String,
        data: bool
    }
    code - 为success表示成功
    data - Track的结果，true/false
  */
  Track(eventName, eventParams) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，根据一组构件ID和名称，批量查询构件信息
  @params idNames:Object 字典对象，key为构件ID，value为构件名称
  @params source: String 构件源类型，可选值有：
                              "PublicSpace", 公共空间，
                              "TeamSpace", 团队空间
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: array<Object>
      }
      code - 为success表示成功
      data - 查询到的构件对象列表，其结构为：
      [
          {
            sourceId: String,                 // 查询时传入的ID
            idInDocument: String,             // 构件在文档中的ElementId
            nameInDocument: String,           // 构件在文档中的名称
            instanceCountInDocument: Integer, // 构件在文档中的实例数量
            idInProject: String,              // 构件在(协同)项目中的ID
            nameInProject: String,            // 构件在(协同)项目中的名称
            revisionInProject: String,        // 构件在(协同)项目中的修订版本
          }
      ]
  */
  ListComponentsByIdNames(idNames, source) {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，检测是否开启高清屏支持
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: bool
      }
      code - 为success表示成功
      data - 若开启高清屏支持，则为true；否则，未false
  */
  IsDpiAware() {
    return this.#DefaultResponse();
  }
  /*
  @description 调用桌面端，获取屏幕缩放系数
  @params void
  @
  @return a Promise. resolve 结果为：
      {
        code: String,
        message: String,
        data: Number(double)
      }
      code - 为success表示成功
      data - 屏幕缩放系数
  */
  GetDevicePixelRatio() {
    return this.#DefaultResponse();
  }
}

/* @description Desktop Client 扩展类, 适配未知的桌面端版本*/
class DesktopClient_None extends IDesktopClient {
  /* @description 构造函数*/
  constructor() {
    super();
  }
}

/* @description Desktop Client 扩展类, 适配1.0.0.0及之后的桌面端版本*/
class DesktopClient_Since_1_0_0_0 extends IDesktopClient {
  /* @description 构造函数*/
  constructor() {
    super();
  }
  /* @description 确保interop对象已绑定*/
  async __EnsureCefSharpObjectBound() {
    if (typeof CefClient != "undefined") {
      return;
    }

    try {
      /* 对于高版本CefSharp库, 须执行此语句, 低版本CefSharp执行此语句会出错, 为了兼容, 这里在try catch内进行调用 */
      // eslint-disable-next-line no-undef
      await CefSharp.BindObjectAsync("CefClient");
    } catch (e) {
      /* ignored */
    }
  }
  /* @description 接口实现*/
  async CallDesktop(method, params) {
    try {
      await this.__EnsureCefSharpObjectBound();
      if (typeof CefClient == "undefined") {
        return this.__FilterError({
          code: "failure",
          message: "CefClient is undefined!",
          data: null,
        });
      }

      let requestObj = {
        path: method,
        params: params,
      };

      let responseStr = await CefClient.Send(JSON.stringify(requestObj));
      return this.__FilterError(this.__JSONParse(responseStr));
    } catch (e) {
      return this.__FilterError({
        code: "failure",
        message: e.toString(),
        data: null,
      });
    }
  }
  /* @description 接口实现*/
  async GetDesktopInfo() {
    let method = "gjw/desktop/common/v1/desktop_info";
    let params = {};

    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async NavigateToBrowser(targetUrl) {
    let method = "gjw/desktop/common/v1/navigate_to_browser";
    let params = {
      targetUrl: targetUrl,
    };

    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetSpecialFolder(type) {
    let method = "gjw/desktop/fs/special_folder";
    let params = {
      type: type,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async DeleteFile(filePath) {
    let method = "gjw/desktop/fs/delete_file";
    let params = {
      filePath: filePath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async DeleteFiles(dirPath, recursive, filter) {
    let method = "gjw/desktop/fs/delete_files";
    let params = {
      dirPath: dirPath,
      recursive: recursive,
      filter: filter,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ExistFile(filePath) {
    let method = "gjw/desktop/fs/exist_file";
    let params = {
      filePath: filePath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ExistDirectory(dirPath) {
    let method = "gjw/desktop/fs/exist_directory";
    let params = {
      dirPath: dirPath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async CreateDirectory(dirPath) {
    let method = "gjw/desktop/fs/create_directory";
    let params = {
      dirPath: dirPath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async IsDirectoryEmpty(dirPath) {
    let method = "gjw/desktop/fs/is_directory_empty";
    let params = {
      dirPath: dirPath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async DeleteDirectory(dirPath, recursive) {
    let method = "gjw/desktop/fs/delete_directory";
    let params = {
      dirPath: dirPath,
      recursive: recursive,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ReadTextFromFile(filePath, encoding) {
    let method = "gjw/desktop/fs/read_text_from_file";
    let params = {
      filePath: filePath,
      encoding: encoding,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async WriteTextToFile(filePath, content, encoding) {
    let method = "gjw/desktop/fs/write_text_to_file";
    let params = {
      filePath: filePath,
      content: content,
      encoding: encoding,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async CopyFile(srcFilePath, destFilePath, overwrite) {
    let method = "gjw/desktop/fs/copy_file";
    let params = {
      srcFilePath: srcFilePath,
      destFilePath: destFilePath,
      overwrite: overwrite,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async DownloadFile(remoteUrl, localFilePath, overwrite) {
    let method = "gjw/desktop/fs/download_file";
    let params = {
      remoteUrl: remoteUrl,
      localFilePath: localFilePath,
      overwrite: overwrite,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async DownloadFileCancelable(
      remoteUrl,
      localFilePath,
      overwrite,
      cancelToken
  ) {
    let method = "gjw/desktop/fs/download_file_cancelable";
    let params = {
      remoteUrl: remoteUrl,
      localFilePath: localFilePath,
      overwrite: overwrite,
      cancelToken: cancelToken,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async CancelTask(cancelToken) {
    let method = "gjw/desktop/task/cancel";
    let params = {
      cancelToken: cancelToken,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetFileMd5(filePath) {
    let method = "gjw/desktop/fs/file_md5";
    let params = {
      filePath: filePath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ShowMask(options) {
    let method = "gjw/desktop/window/mask/show";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async HideMask(options) {
    let method = "gjw/desktop/window/mask/hide";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ListComponentsByNames(componentNames) {
    let method = "gjw/desktop/component/list_by_names";
    let params = {
      componentNames: componentNames,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async LoadComponent(options) {
    let method = "gjw/desktop/component/load";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async PlaceComponent(options) {
    let method = "gjw/desktop/component/place";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ListModelLinksByDirPath(dirPath) {
    let method = "gjw/desktop/model/link/list_by_dir_path";
    let params = {
      dirPath: dirPath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async LinkModel(options) {
    let method = "gjw/desktop/model/link";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ReloadModelLink(linkId, options) {
    let method = "gjw/desktop/model/link/reload";
    let params = {
      linkId: linkId,
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ReloadModelLinkFrom(filePath, linkId, options) {
    let method = "gjw/desktop/model/link/reload_from";
    let params = {
      filePath: filePath,
      linkId: linkId,
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ListCADLinksByDirPath(dirPath) {
    let method = "gjw/desktop/cad/link/list_by_dir_path";
    let params = {
      dirPath: dirPath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetActiveView() {
    let method = "gjw/desktop/view/active";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ListLevels() {
    let method = "gjw/desktop/level/list";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async LinkCAD(options) {
    let method = "gjw/desktop/cad/link";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ReloadCADLink(linkId, options) {
    let method = "gjw/desktop/cad/link/reload";
    let params = {
      linkId: linkId,
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ReloadCADLinkFrom(filePath, linkId, options) {
    let method = "gjw/desktop/cad/link/reload_from";
    let params = {
      filePath: filePath,
      linkId: linkId,
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ImportCAD(options) {
    let method = "gjw/desktop/cad/import";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async SelectFiles(options) {
    let method = "gjw/desktop/fs/select_files";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async SelectDirectory(options) {
    let method = "gjw/desktop/fs/select_directory";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ClipboardSetText(text) {
    let method = "gjw/desktop/clipboard/set_text";
    let params = {
      text: text,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async LoadModule(options) {
    let method = "gjw/desktop/module/load";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async OpenAndActivateDocument(options) {
    let method = "gjw/desktop/document/open_and_activate";
    let params = {
      filePath: options.filePath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetActiveDocument() {
    let method = "gjw/desktop/document/active";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async LoadTemplate(options) {
    let method = "gjw/desktop/template/load";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetUserInfo() {
    let method = "gjw/desktop/user/info";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async RevealInExplorer(path) {
    let method = "gjw/desktop/fs/reveal_in_explorer";
    let params = {
      path: path,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async StartMigration(options) {
    let method = "gjw/desktop/fs/start_migration";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async RectifyJunction(srcPath, destPath) {
    let method = "gjw/desktop/fs/rectify_junction";
    let params = {
      srcPath: srcPath,
      destPath: destPath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetDirectorySize(dirPath) {
    let method = "gjw/desktop/fs/dir_size";
    let params = {
      dirPath: dirPath,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetDriveInfo(path) {
    let method = "gjw/desktop/fs/drive_info";
    let params = {
      path: path,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async CreateZipFromDirectory(options) {
    let method = "gjw/desktop/compression/create_zip_from_directory";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ExtractZipToDirectory(options) {
    let method = "gjw/desktop/compression/extract_zip_to_directory";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async LoadComponents(options) {
    let method = "gjw/desktop/component/batch/load";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
}

/* @description Desktop Client 扩展类, 适配1.3.0.0及之后的桌面端版本*/
class DesktopClient_Since_1_3_0_0 extends DesktopClient_Since_1_0_0_0 {
  /* @description 构造函数*/
  constructor() {
    super();
  }
  /* @description 接口实现*/
  async OpenAndActivateDocument(options) {
    let method = "gjw/desktop/document/open_and_activate";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async PerformMouseClickInBrowser(options) {
    let method = "gjw/desktop/browser/perform_mouse_click";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async SetDialogAutoSelectInBrowser(options) {
    let method = "gjw/desktop/browser/set_dialog_auto_select";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async EmitWebEvent(options) {
    let method = "gjw/desktop/web_event/emit";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  LinkIFC(options) {
    let method = "gjw/desktop/ifc/link";
    let params = {
      options: options,
    };
    return this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  ReloadIFCLinkFrom(filePath, linkId, options) {
    let method = "gjw/desktop/ifc/link/reload_from";
    let params = {
      filePath: filePath,
      linkId: linkId,
      options: options,
    };
    return this.CallDesktop(method, params);
  }
}

/* @description Desktop Client 扩展类, 适配1.5.0.0及之后的桌面端版本*/
class DesktopClient_Since_1_5_0_0 extends DesktopClient_Since_1_3_0_0 {
  /* @description 构造函数*/
  constructor() {
    super();
  }
  /* @description 接口实现*/
  async CreateBrowserWindow(options) {
    let method = "gjw/desktop/browser/create_window";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async DragMoveBrowserWindow() {
    let method = "gjw/desktop/browser/drag_move_window";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async CloseBrowserWindow() {
    let method = "gjw/desktop/browser/close_window";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async SaveGjwUserInfo(gjwUserInfo) {
    let method = "gjw/desktop/user/gjw/save_user_info";
    let params = {
      gjwUserInfo: gjwUserInfo,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetBrowserCustomInputData() {
    let method = "gjw/desktop/browser/get_custom_input_data";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async SetBrowserCustomOutputData(options) {
    let method = "gjw/desktop/browser/set_custom_output_data";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetProjectAreaName() {
    let method = "gjw/desktop/project/current/area_name";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetProject() {
    let method = "gjw/desktop/project/current";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetHostEdition() {
    let method = "gjw/desktop/host/volatile/edition";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetHostFromEntrance() {
    let method = "gjw/desktop/host/volatile/from_entrance";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetHostActiveEnv() {
    let method = "gjw/desktop/host/env/active";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetHostEndpoint(key) {
    let method = "gjw/desktop/host/env/endpoint";
    let params = {
      key: key,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async Track(eventName, eventParams) {
    let method = "gjw/desktop/analyze/track";
    let params = {
      eventName: eventName,
      eventParams: eventParams,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ListComponentsByIdNames(idNames, source) {
    let method = "gjw/desktop/component/list_by_id_names";
    let params = {
      idNames: idNames,
      source: source,
    };
    return await this.CallDesktop(method, params);
  }
}

/* @description Desktop Client 扩展类, 适配1.6.0.0及之后的桌面端版本*/
class DesktopClient_Since_1_6_0_0 extends DesktopClient_Since_1_5_0_0 {
  /* @description 构造函数*/
  constructor() {
    super();
  }
  /* @description 接口实现*/
  async IsDpiAware() {
    let method = "gjw/desktop/browser/is_dpi_aware";
    let params = {};
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async GetDevicePixelRatio() {
    let method = "gjw/desktop/browser/device_pixel_ratio";
    let params = {};
    return await this.CallDesktop(method, params);
  }
}

/* @description Desktop Client 工厂类, 自动根据桌面端版本号, 创建对应的Desktop Client实例*/
class DesktopClientFactory {
  /* @description 构造函数*/
  constructor() {
    this.availableClientTypes = [
      { sinceVersion: "0.0.0.0", clientType: DesktopClient_None },
      { sinceVersion: "1.0.0.0", clientType: DesktopClient_Since_1_0_0_0 },
      { sinceVersion: "1.3.0.0", clientType: DesktopClient_Since_1_3_0_0 },
      { sinceVersion: "1.5.0.0", clientType: DesktopClient_Since_1_5_0_0 },
      { sinceVersion: "1.6.0.0", clientType: DesktopClient_Since_1_6_0_0 },
    ]; // 版本号须按递增顺序
  }

  static #_factory = null;
  /* @description DesktopClientFactory工厂单例*/
  static get Factory() {
    if (!this.#_factory) {
      this.#_factory = new DesktopClientFactory();
    }

    return this.#_factory;
  }
  /*
  @description 将桌面端版本号拆分为4位数字
  @params version:String 桌面端版本号
  @
  @return versionParts:Int[4]. 点分版本号数组, 元素类型为Integer, 数组长度为4
  */
  #SplitDesktopVersion(version) {
    let adjustedVersion = version.trim();

    // 处理带'V'的老版本号
    if (adjustedVersion.startsWith("V")) {
      adjustedVersion = adjustedVersion.substring(1).trim();
    }

    let versionNumbers = [];
    const versionParts = adjustedVersion.split(".");
    const count = versionParts.length;
    for (let i = 0; i < count; ++i) {
      versionNumbers.push(parseInt(versionParts[i]));
    }

    // 补齐版本号为4位
    for (let i = count; i < 4; ++i) {
      versionNumbers.push(0);
    }

    return versionNumbers;
  }
  /*
  @description 比较桌面端版本号
  @params version1:String 桌面端版本号1
  @params version2:String 桌面端版本号2
  @
  @return an Integer. 若version1 > version2, 则返回正数; 若version1 < version2, 则返回负数; 否则返回0
  */
  #CompareDesktopVersion(version1, version2) {
    const version1Numbers = this.#SplitDesktopVersion(version1);
    const version2Numbers = this.#SplitDesktopVersion(version2);

    if (version1Numbers.length != 4 || version2Numbers.length != 4) {
      throw "size of desktop version numbers must be 4!";
    }

    for (let i = 0; i < 4; ++i) {
      if (version1Numbers[i] > version2Numbers[i]) {
        return 1;
      }

      if (version1Numbers[i] < version2Numbers[i]) {
        return -1;
      }
    }

    return 0;
  }
  /*
  @description 获取或创建IDesktopClient实例对象
  @params void
  @
  @return IDesktopClient实例对象
  */
  async GetClient() {
    let desktopVersion = "-.-.-.-";
    if (typeof this.client == "undefined" || this.client === null) {
      for (let i = this.availableClientTypes.length - 1; i >= 0; --i) {
        const sinceVersion = this.availableClientTypes[i].sinceVersion;
        const availableClient = new this.availableClientTypes[i].clientType();

        const desktopInfoResult = await availableClient.GetDesktopInfo();
        if (desktopInfoResult.code != "success") {
          continue;
        }

        desktopVersion = desktopInfoResult.data.desktopVersion;
        const compareResult = this.#CompareDesktopVersion(
            desktopVersion,
            sinceVersion
        );
        if (compareResult > 0 || compareResult == 0) {
          this.client = availableClient;
          console.info(
              `desktop version:'${desktopVersion}', DesktopClient created from Type '${this.availableClientTypes[i].clientType.name}'`
          );
          break;
        }
      }
    }

    if (typeof this.client == "undefined" || this.client === null) {
      this.client = new DesktopClient_None();
      console.info(
          `desktop version:'${desktopVersion}', DesktopClient created from Type '${DesktopClient_None.name}'`
      );
    }

    return this.client;
  }
}

/*
@description 初始化DesktopClient实例对象
@params errorHandler:Function 错误处理回调函数, 其签名为: (errorCode:String, errorMessage:String) -> void
@
@return IDesktopClient实例对象
*/
async function InitDesktopClient(errorHandler) {
  // 向DesktopClient实例注册错误处理回调
  const desktopClient = await DesktopClientFactory.Factory.GetClient();
  desktopClient.SetErrorHandler(errorHandler);
  // 设置bigInt转json
  BigInt.prototype.toJSON = function () {
    return this.toString(); // not supported: JSON.rawJSON(this.toString());
  };
  return desktopClient;
}

export { InitDesktopClient }
